<template>
    <h2 class="text-center mx-auto text--secondary">
        {{ title }}
    </h2>
    <h4 v-if="subtitle" class="text-center mx-auto text--secondary">
        {{ subtitle }}
    </h4>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class MainHeader extends Vue {
        @Prop() title
        @Prop() subtitle
    }

    export default MainHeader
</script>
